import { Directive } from '@angular/core';
import { FormErrorConnectorDirective } from '../form-error-connector.directive';
import { BaseFormConnectorDirective } from './base-form-connector.directive';

@Directive({
  selector: '[dsdExtInputConnector], dsd-input:not([dsd-ext-input]), dsd-textarea',
  providers: [
    {
      provide: FormErrorConnectorDirective,
      useExisting: InputConnectorDirective
    }
  ],
  standalone: false
})
export class InputConnectorDirective extends BaseFormConnectorDirective {}
